import css from './GrandTotalStep3Buttons.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import {
    notifyErrorCustom,
    notifySuccessCustom,
} from '@shared/Widgets/ToastNotifications/ToastNotifications';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import classNames from 'classnames';
import { useAuthorizationViewModel } from '@viewModels/AuthorizationViewModel/AuthorizationViewModel';
import { CustomProjectStep3ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep3ElementsIdsEnum';
import { CartViewModel } from '@viewModels/CartViewModel/CartViewModel';
import { useItemsSelectionStore } from '../../../../../Stores/ItemsSelectionStore';

const IS_AFRIBANK = true;

export const GrandTotalStep3Buttons: React.FC = () => {
    const cartViewModel = new CartViewModel();

    const { bearerToken } = useAuthorizationViewModel();
    const { addAllToCartLoading, addSelectedToCartLoading, selectedItems } =
        useItemsSelectionStore();

    const { projectId } = useParams();
    const [isDesktop] = useMediaType();

    const handleAddAllToCart = async () => {
        const response = await cartViewModel.addAllItemsToCart();
        if (response.error) {
            notifyErrorCustom('Failed to add items to cart');
            return;
        }
        notifySuccessCustom('Items successfully added to cart');

        if (response.data) {
            window.open(
                response.data.cashBuildCart.url,
                '_parent',
                'noopener,noreferrer'
            );
        }
    };

    const handleAddSelectedToCart = async () => {
        const response = await cartViewModel.addSelectedItemsToCart();

        if (response.error) {
            notifyErrorCustom('Failed to add items to cart');
            return;
        }
        notifySuccessCustom('Items successfully added to cart');

        if (response.data) {
            window.open(
                response.data.cashBuildCart.url,
                '_parent',
                'noopener,noreferrer'
            );
        }
    };

    const pdfLink = `${import.meta.env.VITE_BASE_URL_LINK}/generate-pdf/project/${projectId}?token=${bearerToken}`;

    return (
        <>
            {isDesktop ? (
                <div className={css.footerBtns}>
                    <BasicButton
                        id={
                            CustomProjectStep3ElementsIdsEnum.TOTAL_PRICE_PAGE_STEP3_BLOCK_PDF_BUTTON
                        }
                        className={css.pdfLinkBtn}
                        extraClassName={'reverse'}
                        disabled={
                            addAllToCartLoading || addSelectedToCartLoading
                        }
                    >
                        <a href={pdfLink} className={css.pdfLink}>
                            Download PDF
                        </a>
                    </BasicButton>

                    <BasicButton
                        onClick={handleAddAllToCart}
                        isLoading={addAllToCartLoading}
                        extraClassName={css.grandTotalSelectedFooterBtn}
                        id={
                            CustomProjectStep3ElementsIdsEnum.TOTAL_PRICE_PAGE_STEP3_BLOCK_ALL_TO_CART_BUTTON
                        }
                        disabled={addSelectedToCartLoading || IS_AFRIBANK}
                    >
                        Add all to cart
                    </BasicButton>

                    <BasicButton
                        onClick={handleAddSelectedToCart}
                        extraClassName={`${css.grandTotalSelectedFooterBtn} ${css.reverse} ${addSelectedToCartLoading && css.loading}`}
                        isLoading={addSelectedToCartLoading}
                        disabled={
                            addAllToCartLoading ||
                            selectedItems.length < 1 ||
                            IS_AFRIBANK
                        }
                        id={
                            CustomProjectStep3ElementsIdsEnum.TOTAL_PRICE_PAGE_STEP3_BLOCK_SELECTED_TO_CART_BUTTON
                        }
                    >
                        Add selected to cart
                    </BasicButton>
                </div>
            ) : (
                <div className={css.footerBtns}>
                    <BasicButton
                        onClick={handleAddAllToCart}
                        extraClassName={classNames(
                            css.grandTotalSelectedFooterBtn,
                            css.btn
                        )}
                        isLoading={addAllToCartLoading}
                        disabled={addSelectedToCartLoading || IS_AFRIBANK}
                    >
                        Add all to cart
                    </BasicButton>

                    <div className={css.saveAndDownloadBtns}>
                        <BasicButton
                            onClick={handleAddSelectedToCart}
                            extraClassName={classNames(
                                css.grandTotalSelectedFooterBtn,
                                css.btn
                            )}
                            isLoading={addSelectedToCartLoading}
                            isReversed={true}
                            disabled={
                                addAllToCartLoading ||
                                selectedItems.length < 1 ||
                                IS_AFRIBANK
                            }
                        >
                            Add selected to cart
                        </BasicButton>

                        <BasicButton
                            className={css.pdfLinkBtn}
                            extraClassName={css.reverse}
                            disabled={
                                addAllToCartLoading || addSelectedToCartLoading
                            }
                        >
                            <a href={pdfLink} className={css.pdfLink}>
                                Download PDF
                            </a>
                        </BasicButton>
                    </div>
                </div>
            )}
        </>
    );
};
